define([], function () {
  var show = function (link) {
    var url = link.attr('href');
    var jobId = link.attr('data-id');

    $.ajax({
      type: 'GET',
      url: url,
      success: function (result) {
        if(result.job_html) {
          var jobs_wrap = $('.jobs .jobs-list .jobs-wrap');
          var job_item = link.parents('.job-item');
          jobs_wrap.find('.full-job.job-item').remove();
          jobs_wrap.find('.job-item').show();
          job_item.hide();
          job_item.after(result.job_html);

          window.history.pushState('data', '', window.location.pathname + '?job_id=' + jobId);
        }
      }
    });
  };

  var close = function(jobItem){
    jobItem.remove();
    window.history.pushState('data', '', window.location.pathname);
    $('.jobs-list .jobs-wrap .job-item').show();
  };

  var disable = function(jobItem){
    jobItem.on('click', function(){ return false });
    jobItem.tooltip({container: 'body'})
  };

  var jobsSectionShow = function(state){
    $('.jobs-list-section[data-state="'+state+'"]').show();
  };

  var jobsSectionHide = function(state){
    $('.jobs-list-section[data-state="'+state+'"]').hide();
  };

  var jobsListSelection = function(state, list){
    var stateJobsIds = list.map(function(job) { return job.id });
    $('.jobs-list-section[data-state="'+state+'"] .jobs-list-item').each(function(){
      stateJobsIds.includes($(this).data('id')) ? $(this).show() : $(this).hide();
    });
    $('#'+state).collapse('show');
    $('.jobs-list-section[data-state="'+state+'"] .jobs-list-count').html(list.length);
  };

  var jobsHide = function(state){
    $('.jobs-list-section[data-state="'+state+'"] .jobs-list-item').hide();
    $('#'+state).collapse('hide');
    $('.jobs-list-section[data-state="'+state+'"] .jobs-list-count').html(0);
  };

  var jobsShow = function(state, list){
    jobsSectionShow(state);
    if(list){
      jobsListSelection(state, list);
    }else{
      jobsHide(state);
    }
  };

  var dashboardFilter = function(params) {
    var job_filter = params.job_filter;
    var el = params.el;
    var resultContainer = el.parents('.dropdown').find('a .value');

    resultContainer.attr('data-value', el.attr('data-value'));
    resultContainer.html(el.html());
    if (resultContainer.attr('data-value')) {
      resultContainer.parent().css('color', '#00c5ec');
    } else {
      resultContainer.parent().css('color', '');
    }

    var filter_params = {
      job_state: $('.filters-jobs .value').attr('data-value'),
      employment_type: $('.filters-employment-type .value').attr('data-value'),
      experiences: [$('.filters-experiences .value').attr('data-value')],
      office: $('.filters-office .value').attr('data-value'),
      team: $('.filters-team .value').attr('data-value'),
      job_function: $('.filters-job-function .value').attr('data-value')
    };

    var url = job_filter.attr('data-url');
    var data = { filter_params: filter_params };
    var jobsStates = ['active', 'draft', 'closed'];

    var jobsListShow = function(jobs){
      if(jobsStates.includes(filter_params.job_state)){
        jobsStates.forEach(function(state) {
          if(state != filter_params.job_state){
            jobsSectionHide(state);
          }else{
            jobsShow(state, jobs[state]);
          }
        });
      }else{
        jobsStates.forEach(function(state) {
          jobsShow(state, jobs[state]);
        });
      }
      if(jobs['active']){
        $('.jobs-list-empty').addClass('hide');
        $('.jobs-list-line').removeClass('hide');
      }else{
        $('.jobs-list-empty').removeClass('hide');
        $('.jobs-list-line').addClass('hide');
      }
    };

    $.ajax({
      type: 'GET',
      url: url,
      data: data,
      success: function(result){
        if(result.jobs){
          jobsListShow(result.jobs);
          $('.wrapper').collapse({toggle: false});
          if(filter_params.job_state == 'closed') $('#closed').collapse('show');
        }
      }
    });
  };

  var careersFilter = function(options) {
    var $filter = options.$filter;
    var url = $filter.attr('data-url');
    var $el = options.$el;
    var resultContainer = $el.parents('.dropdown').find('a .value');

    resultContainer.attr('data-value', $el.attr('data-value'));
    resultContainer.html($el.html());
    resultContainer.parent().toggleClass('active', resultContainer.attr('data-value'))

    var filter_params = {
      location: [$filter.find('.filters-location .value').attr('data-value')],
      team: [$filter.find('.filters-team .value').attr('data-value')],
      employment_type: [$filter.find('.filters-employment-type .value').attr('data-value')],
      job_function: [$filter.find('.filters-job-function .value').attr('data-value')],
    };

    $.extend(filter_params, options.params);

    $.ajax({
      type: 'GET',
      url: url,
      data: { filter_params: filter_params },
      success: function(result){
        if(result.jobs_html){
          options.$list.html(result.jobs_html);
        }
      }
    });
  };

  var partnersboardFilter = function(params){
    var job_filter = params.job_filter;
    var el = params.el;
    var resultContainer = el.parents('.dropdown').find('a .value');

    resultContainer.attr('data-value', el.attr('data-value'));
    resultContainer.html(el.html());
    if (resultContainer.attr('data-value')) {
      resultContainer.parent().css('color', '#00c5ec');
    } else {
      resultContainer.parent().css('color', '');
    }

    var filter_params = {
      job_state: $('.filters-jobs .value').attr('data-value'),
      employment_type: $('.filters-employment-type .value').attr('data-value'),
      experiences: [$('.filters-experiences .value').attr('data-value')],
      office: $('.filters-office .value').attr('data-value'),
      partner: $('.filters-partner .value').attr('data-value'),
      job_function: $('.filters-job-function .value').attr('data-value')
    };

    var url = job_filter.attr('data-url');
    var data = { filter_params: filter_params };
    var jobsStates = ['new', 'approved', 'deleted', 'closed'];

    var jobsListShow = function(jobs){
      if(jobsStates.includes(filter_params.job_state)){
        jobsStates.forEach(function(state) {
          if(state != filter_params.job_state){
            jobsSectionHide(state);
          }else{
            jobsShow(state, jobs[state]);
          }
        });
      }else{
        jobsStates.forEach(function(state) {
          jobsShow(state, jobs[state]);
        });
      }
      if(jobs['new']){
        $('.jobs-list-empty').addClass('hide');
        $('.jobs-list-line').removeClass('hide');
      }else{
        $('.jobs-list-empty').removeClass('hide');
        $('.jobs-list-line').addClass('hide');
      }
    };

    $.ajax({
      type: 'GET',
      url: url,
      data: data,
      success: function(result){
        if(result.partners_jobs){
          jobsListShow(result.partners_jobs);
          $('.wrapper').collapse({toggle: false});
          if(filter_params.job_state == 'closed') $('#closed').collapse('show');
        }
      }
    });
  };

  return {
    show: show,
    close: close,
    disable: disable,
    dashboardFilter: dashboardFilter,
    careersFilter: careersFilter,
    partnersboardFilter: partnersboardFilter
  };
});
